import './App.css';
import React, { useEffect } from 'react';
import { Switch } from 'react-router-dom';
import Nav from './components/Navigation/Navigation';

import ApprovalManagement from './containers/ApprovalManagement';
import {
  SIGNIN_ROUTE,
  FORGET_PWD_ROUTE,
  FINANCE_MODULE_ROUTE,
  DASHBOARD_MODULE_ROUTE,
  USER_MANAGEMENT_MODULE_ROUTE,
  FINANCE_MANAGEMENT_MODULE_ROUTE,
  ATHENEUM_ROUTE_PREFIX,
  LAUNCH_MANAGEMENT_ROUTE_PREFIX,
  AKADEMY_ROUTE,
  AFFILIATED_ROUTE_PREFIX,
  TEENYEBEANS_PORTAL_ROUTE_PREFIX,
  BUZZONE_ROUTE,
} from './routes/routes';

import SignInScreen from './auth/SignInScreen/SignInScreen';
import { getUser, isValidToken } from './auth/utils/jwtValidator';
import { useDispatch, useSelector } from 'react-redux';
import {
  getMeApiAsync,
  logOut,
  userLoaded,
  userLoading,
} from './auth/SignInScreen/SigninStore/signinSlice';
import PublicRoute from './auth/Routes/PublicRoute';
import PrivateRoute from './auth/Routes/PrivateRoute';
import ForgetPwdScreen from './auth/ForgetPwdScreen/ForgetPwdScreen';
import DashboardScreen from './containers/Dashboard';
import DashboardLanding from './containers/Dashboard/DashboardLanding';
import UserManagementScreen from './containers/UserManagement/UserManagementScreen';
import FinanceManagementScreen from './containers/FinanceManagement/FinanceManagementScreen';
import Atheneum from './containers/Atheneum/Atheneum';
import { Box } from '@material-ui/core';
import useScopes from './hooks/useScopes';
import LaunchManagementScreen from './containers/LaunchManagement/LaunchManagementScreen';
import Akademy from './containers/Akademy/Akademy';
import AffiliatedMarketing from './containers/AffiliatedMarketing/AffiliatedMarketing';
import TeenybeansPortalScreen from './containers/TeenybeansPortal/TeenybeansPortalScreen';
import BuzzOne from './containers/BuzzOne/BuzzOne';

const DoNotHaveAccess = () => {
  return (
    <Box
      fontFamily={'Rubik'}
      width={'100%'}
      minHeight={400}
      display="flex"
      justifyContent={'center'}
      alignItems="center">
      <Box maxWidth={500} fontSize={16} textAlign={'center'}>
        <Box mb={1}>You do not have access to this feature</Box>
        <Box fontSize={12}>
          NOTE: You are seeing this screen because you did not complete your KYC
          or you do not have permission to view this screen or You are not a
          PLATINUM member
        </Box>
      </Box>
    </Box>
  );
};

export default function App() {
  const dispatch = useDispatch();
  const { access } = useScopes();
  useEffect(() => {
    dispatch(userLoading());
    if (isValidToken()) {
      const user = getUser();

      if (user === null) {
        dispatch(logOut());
      } else {
        dispatch(userLoaded(user));
        dispatch(getMeApiAsync());
      }
    } else {
      dispatch(logOut());
    }
  }, []);

  const { moduleAccess } = useSelector(({ signInReducer }) => {
    return {
      moduleAccess: signInReducer.me
        ? signInReducer.me.data
          ? signInReducer.me.data.role
          : []
        : [],
    };
  });

  return (
    <>
      <Switch>
        <PublicRoute path={SIGNIN_ROUTE} exact component={SignInScreen} />
        <PublicRoute
          path={FORGET_PWD_ROUTE}
          exact
          component={ForgetPwdScreen}
        />

        <Nav>
          <PrivateRoute
            path="/"
            exact
            component={
              moduleAccess.includes('bccSuperAdmin')
                ? DashboardLanding
                : DoNotHaveAccess
            }
          />
          <PrivateRoute
            path={DASHBOARD_MODULE_ROUTE}
            component={
              moduleAccess.includes('bccSuperAdmin')
                ? DashboardScreen
                : DoNotHaveAccess
            }
          />

          <PrivateRoute
            path={FINANCE_MODULE_ROUTE}
            component={ApprovalManagement}
          />
          <PrivateRoute
            path={USER_MANAGEMENT_MODULE_ROUTE}
            component={UserManagementScreen}
          />
          <PrivateRoute
            path={FINANCE_MANAGEMENT_MODULE_ROUTE}
            component={FinanceManagementScreen}
          />
          <PrivateRoute
            path={ATHENEUM_ROUTE_PREFIX}
            component={
              moduleAccess.includes('bccSuperAdmin') ||
              access({
                mode: 'allOf',
                scope: ['atheneum:readWrite'],
              })
                ? Atheneum
                : DoNotHaveAccess
            }
          />
          <PrivateRoute
            path={LAUNCH_MANAGEMENT_ROUTE_PREFIX}
            component={LaunchManagementScreen}
          />
          <PrivateRoute path={AKADEMY_ROUTE} component={Akademy} />
          <PrivateRoute
            path={AFFILIATED_ROUTE_PREFIX}
            component={AffiliatedMarketing}
          />
          <PrivateRoute
            path={TEENYEBEANS_PORTAL_ROUTE_PREFIX}
            component={TeenybeansPortalScreen}
          />
          <PrivateRoute path={BUZZONE_ROUTE} component={BuzzOne} />
        </Nav>
      </Switch>
    </>
  );
}
